// https://www.compart.com/de/unicode/U+2011
// Nicht umbrechender Viertelgeviertstrich
const NON_BREAKING_HYPHEN = '\u2011';

// Geschütztes Leerzeichen
const NO_BREAK_SPACE = '\u00A0';

const SPACE = '\u0020';

// Silbentrennung
const SOFT_HYPHEN = '\u00AD';

const UtfCode = {
    NON_BREAKING_HYPHEN: NON_BREAKING_HYPHEN,
    NO_BREAK_SPACE,
    SPACE,
    SOFT_HYPHEN
}

export default UtfCode;